import React, { useEffect, useRef, useState } from "react";
import { fetchReleaseNotes } from "../utils/Api";
import { showError } from "../ui/Message";
import Card from "../ui/Card";
import Label from "../ui/Label";
import Html from "../utils/Html";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";

export default function ReleaseNotes(props) {

    const { controller = "", route = "", active = false } = props;

    const [results, setResults] = useState([]);




    const ref = useRef(null);

    const getReleaseNotes = () => {
        fetchReleaseNotes("getBMOUpdates", {}, (_s, _r) => {
            if (_s) {
                setResults(_r);
            } else {
                showError({ error: _r?.error || "There was an error" });
            }
        })
    }

    useEffect(getReleaseNotes, []);

    const drawReleaseNote = (_item) => {

        const { post_title = "", post_content = "" } = _item;

        return (
            <div>
                <div>{post_title}</div>
                <Html html={post_content} />
            </div>
        )

    }

    const handleVerticalArrow = (_dir) => {

        ref.current?.scrollBy({
            top: _dir * 60,
            behavior: "smooth"
        });
    };


    useEffect(() => {
        const actions = [

            { key: KBD.ARROW_UP, action: () => handleVerticalArrow(-1) },
            { key: KBD.ARROW_DOWN, action: () => handleVerticalArrow(1) }
        ];

        return listen(controller, route, actions, () => { }, [KBD.ARROW_LEFT, KBD.ARROW_RIGHT, KBD.ARROW_DOWN, KBD.ARROW_UP]);
    }, []);



    // return(<pre>{JSON.stringify(results)}</pre>)

    return (
       
                <Card  tertiary header={<Label style={{ "textAlign": "left", "color": "var(--text)" }}>Release Notes</Label>}   className="bm-release-notes">
                    {/* <pre>{JSON.stringify(results, null, 2)}</pre> */}
                    <div ref={ref}  style={{ "flex": "1 1 0", "minHeight": 0, "overflow": "auto", "padding": "10px", "fontSize": "16px", "scrollbarGutter": "stable", }} >
                        {results.map(item => {
                            return drawReleaseNote(item);
                        })}
                    </div>
                </Card>
         
    )

}